const error = (errorCode = null, action) => {
    switch (action.type) {
      case 'ERROR': // FIXME: real action
        return action.errorCode;
      default:
        return errorCode;
    }
  };
  
  export default error;
  


/** WEBPACK FOOTER **
 ** ./src/reducers/error.js
 **/